export default __webpack_public_path__ + "static/media/I-2019.ec7ec29d.pdf";